/**
 * Files already on a mailbox draft. The Drafts folder is listed live from the
 * provider, so these carry the provider's attachment id instead of a Kjuup
 * attachment row; the backend downloads them again when the draft is saved
 * or sent.
 */
export function draftAttachmentsOf(email) {
  const list = Array.isArray(email?.attachments) ? email.attachments : [];
  return list
    .map((att) => {
      const providerAttachmentId = att?.providerAttachmentId || att?.id;
      if (!providerAttachmentId) return null;
      return {
        id: String(providerAttachmentId),
        providerAttachmentId: String(providerAttachmentId),
        filename: att.filename || "attachment",
        size: Number(att.size) || 0,
        mimeType: att.mimeType || att.contentType || "application/octet-stream",
      };
    })
    .filter(Boolean);
}

/** `draftAttachments` field: the draft files the user kept. */
export function draftAttachmentsField(list) {
  return (list || []).map((att) => ({
    providerAttachmentId: att.providerAttachmentId || att.id,
    filename: att.filename,
    size: att.size,
    contentType: att.mimeType,
  }));
}

/** JSON body, or multipart once new files are attached. */
export function draftRequestBody(payload, files) {
  if (!files || files.length === 0) return payload;
  const formData = new FormData();
  // Text fields first: the backend reads fields that precede the files.
  Object.entries(payload).forEach(([key, value]) => {
    if (value == null) return;
    formData.append(key, Array.isArray(value) ? JSON.stringify(value) : String(value));
  });
  files.forEach((file) => formData.append("attachments", file));
  return formData;
}
